import { useContext, useEffect } from "react";
import { QCContext, UserContext } from "../../context/UserContext";
import { getPOLinkedBinList, getPOList, getQCRequests } from "../../services/qcService";
import { fetchProjectData } from "../../services/station";
import styles from './BoardView.module.css';

import { useQuery } from "@tanstack/react-query";
import Button from "../../components/Button";
import Tag from "../../components/Tag";
import { Link } from "react-router-dom";

function BoardView() {
  const {workOrder, currentFactory, toastList, setToastList} = useContext(UserContext);
  const {data: poList, isLoading} = useQuery(['qcCheckPOlist', workOrder], async () => {
    let filteredData = {};
    const projectList = await fetchProjectData(
      {
        _factory_code: currentFactory.item_code,
        stockpile_id: workOrder.id,
        hideinactive : false
      }
    )
    if (projectList.status === 200) {
      const poList = await getPOList({
        factory_code: currentFactory.item_code,
        projects_list: projectList.message.projects
      });
      poList.map(po => {
        filteredData[po.customer_order_id] = po;
        return po;
      })
      // if (poList.status !== 200) {
      //   showToast({type: 'error', message: poList.message || 'Internal Server Error', autoClose: false});
      // } else {
        const linkedBin = await getPOLinkedBinList({
          factory_code: currentFactory.item_code,
          po_codes: poList.map((project) => project.customer_order_id)
        });

        if (linkedBin.status === 200) {
          // check other conditions
          linkedBin.message.map((binObj) => {
            if (filteredData[binObj.po_code] !== undefined) {
              filteredData[binObj.po_code].bin = filteredData[binObj.po_code].bin ? (filteredData[binObj.po_code].bin + ', ' + binObj.bin) : binObj.bin
            } 
            return binObj;
          })
        } else {
          showToast({type: 'error', message: linkedBin.message || 'Internal Server Error', autoClose: false});
        }
      // }
      return filteredData
    } else {
      showToast({type: 'error', message: projectList.message || 'Internal Server Error', autoClose: false});
      return filteredData
    }
  }, {
    refetchOnWindowFocus: false,
    retry: false
  })

  const {data: qcNumberList} = useQuery(['qcRequestList', poList], async () => {
    let filteredData = {};
    if (poList && Object.keys(poList).length > 0) {
      const qcList = await getQCRequests({
        po_code: Object.keys(poList).join(','),
        factory_code: currentFactory.item_code
      })
      if (qcList.status === 200) {
        qcList.message.map((qcObj) => {
          if (filteredData[qcObj.project]) {
            filteredData[qcObj.project].push(qcObj)
            filteredData[qcObj.project] = filteredData[qcObj.project].sort(function(a,b){
              return new Date(b.modified) - new Date(a.modified);
            });
          } else {
            filteredData[qcObj.project] = [qcObj];
          }
        })
        let result = {};
        for (var i in filteredData) {
          result[i] = {};
          result[i].qcList = filteredData[i].map(item => item.request_id).join(', ');
          if (filteredData[i].length > 1 && filteredData[i][0].status === 'pending') {
              result[i].status = 'rework';
          } else {
            result[i].status = filteredData[i][0].status;
          }
        }
        return result;
      } else {
        showToast({type: 'error', message: qcList.message || 'Internal Server Error', autoClose: false});
      }
    }
    return Promise.resolve(filteredData)
  }, {
    refetchInterval: 3000*60
  })  

  const showToast = ({type, message, action, autoClose = true}) => {
    // show toast message
    let toast = {
      type: type,
      text: message,
      onClick: action ? () => console.log('button clicked') : undefined,
      autoClose: autoClose
    }
    setToastList([...toastList, toast]);
  }

  const qcStatusMap = {
    pending: {
      type: 'tertiary',
      fillStyle: 'filled',
      label: 'Pending'
    },
    completed: {
      type: 'primary',
      fillStyle: 'outline',
      icon: 'check_circle',
      label: 'Completed'
    },
    rework: {
      type: 'tertiaryBlue',
      fillStyle: 'filled',
      icon: 'check_circle',
      label: 'Rework'
    },
    rejected: {
      type: 'tertiaryRed',
      fillStyle: 'outline',
      icon: 'close',
      label: 'Rejected'
    }
  }

  if (isLoading) return <div style={{textAlign: 'center'}}>Please wait while we are loading board details. Nevertheless, Barcode scanning will still work</div>

  return (
    <>
      <div className={styles.boardHeader}>
        <div style={{display: 'flex', alignItems: 'center'}}>
          <span style={{fontWeight: 700}}>PO List</span> 
          {/* <span className="ft-12" style={{fontWeight: 400, marginLeft: '4px'}}>({boardData.filteredData.length})</span> */}
        </div>
      </div>
      <div className="table-responsive">
        <table className="table block">
          <thead>
            <tr>
              <th className="ft-12">QC Request Number</th>
              <th className="ft-12">PO code</th>
              <th className="ft-12">BIN LOCATION</th>
              <th className="ft-12">Status</th>
              {/* <th className="ft-12">SORTED QTY</th>
              <th className="ft-12">PROD COMPLETED</th>
              <th className="ft-12">QC REQUEST NUMBER</th> */}
            </tr>
          </thead>
          <tbody>
            {poList && Object.keys(poList).map((item, index) => {
              let poStatus = qcNumberList && qcNumberList[poList[item].project] ? qcNumberList[poList[item].project].status : 'pending'
              return (
                <tr key={index}>
                  <td>{qcNumberList && qcNumberList[poList[item].project] ? (currentFactory.item_code + ' (' + qcNumberList[poList[item].project].qcList + ')' || '-') : '-'}</td>
                  <td>{item}</td>
                  <td>{poList[item].bin || '-'}</td>
                  <td>
                    <Tag type={qcStatusMap[poStatus].type} fillStyle={qcStatusMap[poStatus].fillStyle} icon={qcStatusMap[poStatus].icon}>{qcStatusMap[poStatus].label}</Tag>
                  </td>
                  <td>
                    <Link to={`/dashboard/qccheck/${item}`}>
                      <Button type={'linkSecondary'}>View Details</Button>
                    </Link>
                  </td>
                </tr>
              )
            })}
          </tbody>
        </table>
      </div>
    </>
  );
}

export default BoardView;
